import { render } from "./CveDetail.vue?vue&type=template&id=0f6312d0&scoped=true"
import script from "./CveDetail.vue?vue&type=script&lang=js"
export * from "./CveDetail.vue?vue&type=script&lang=js"

import "./CveDetail.vue?vue&type=style&index=0&id=0f6312d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6312d0"]])

export default __exports__